// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const modalStyles = css`
  div.TCPModal__InnerContent.atb-innerContent {
    right: 0;
    left: auto;
    top: 0;
    bottom: 0;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    ${(props) =>
      `
    padding: 0;
    width: 100%;
    @media ${props.theme.mediaQuery.smallOnly} {
      animation: slide-in-mobile 0.5s forwards;
      border-radius: ${props.theme.spacing.ELEM_SPACING.XS}
        ${props.theme.spacing.ELEM_SPACING.XS} 0px 0px;
    }
    @keyframes slide-in-mobile {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(5%);
      }
    }
    `}
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 350px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 375px;
    }

    .Modal-Header {
      ${(props) =>
        `
      background-color: ${props.theme.colorPalette.gray[300]};
      `}
    }

    .Modal_Heading {
      font-size: 16px;
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      font-weight: ${(props) => props.theme.fonts.fontWeight.semibold};
      line-height: 43px;
      border: none;
      margin-bottom: 0;
      padding: 0;
      display: inline;
      ${(props) =>
        `
      line-height: 46px;
      margin-left: 20px;
      @media ${props.theme.mediaQuery.medium} {
        margin-left: 40px;
      }
      `}

      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) => props.isAddedToBagRedesignEnabled && `margin-left: 37%;`}
      }
    }

    .close-modal {
      right: 18px;
      top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      ${(props) =>
        `
           @media ${props.theme.mediaQuery.smallOnly} {
            padding: 33px 7px 13px 40px;
            right: 0px;
            top: 0px;
            background-position: 45% 58%;
            background-size: auto;
          }`}
    }
    .blurred-content {
      filter: blur(4px);
      -o-filter: blur(4px);
      -ms-filter: blur(4px);
      -moz-filter: blur(4px);
      -webkit-filter: blur(4px);
    }

    .fbt-wrapper {
      overflow: hidden;
      opacity: 1;
    }

    .fbt-wrapper > div {
      margin-top: 0;
    }

    .fbt-complete {
      min-height: 0;
      height: 0;
      transition: height 1.2s ease;
      overflow: hidden;
      opacity: 0;
    }
    .error-notification {
      background-color: ${(props) => props.theme.colorPalette.gray[300]};
      margin-top: -16px;
    }
  }
`;

export const productInfoStyles = css`
  margin-bottom: 10px;
  .product {
    margin: 0;
    width: 100%;
  }
`;

export const pointsInfoStyles = css`
  .row-padding {
    margin: 0;
    width: 100%;
  }
  .divided-line {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
`;

export const buttonActionStyles = css`
  .view-bag-container {
    margin: 0;
    width: 100%;
  }
  .checkout-button {
    margin: 0;
    width: 100%;
  }
`;

const styles = css`
  .modal-heading {
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    justify-content: center;
    text-align: center;
    height: auto;
    display: block;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 17px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      justify-content: center;
      height: auto;
      padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-top: 12px;
      text-align: center;
    }
  }
  .modal-heading:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 51px;
    margin: auto;
    z-index: -1;
    background-color: #f4f4f4;
    bottom: 0;
    left: -17px;
    padding-right: 17px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      left: -17px;
      padding-right: 17px;
    }
  }

  .coupons-container {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 65%;
      overflow: auto;
    }
  }

  .cta-section {
    box-shadow: inset 0px 7px 5px -1px rgba(204, 204, 204, 1);
    padding: 5px ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    position: absolute;
    width: 100%;
    box-sizing: border-box;

    .continue-btn {
      border-radius: 6px;
    }

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-bottom: 30px;
      box-sizing: border-box;
      background: ${(props) => props.theme.colorPalette.white};
    }
  }

  .total-section {
    display: flex;
    justify-content: space-around;
  }

  .offer-notification {
    display: flex;
    justify-content: right;
    align-items: center;
  }
`;

export default styles;
